import $ from 'jquery';

import { i18n } from '../../translation.js';
import FileUploadMultiple from '../file-upload-multiple/file-upload-multiple.js';
import template from './course-signup.vhtml';
import { trackFormSubmit } from '../../scripts/tag-manager';

export default {
	validate: null,
	template,
	components: {
		FileUploadMultiple,
	},
	props: {
		qdPopup: {
			type: Object,
			default: null,
		},
		termsConditions: {
			type: String,
			default: '',
		},
	},
	computed: {
		isFormValid() {
			return Object.keys( this.fields ).reduce( ( valid, key ) => this.fields[key].valid && valid, true );
		},
		headline() {
			switch ( this.submitStatus ) {
			case 'success':
				return i18n.t( 'youSignupForSuccess' );
				break;
			case 'error': 
				return i18n.t( 'youSignupForError' );
				break;
			default:
				return i18n.t( 'youSignupFor' );
			}
		},
		submitMessage() {
			switch ( this.submitStatus ) {
			case 'success':
				return i18n.t( 'confirmationEmailSent' );
				break;
			case 'error': 
				return '';
				break;
			default:
				return '';
			}
		},
	},
	data() {
		return {
			payer: 'P',
			commentary: false,
			popupData: null,
			isSubmitting: false,
			submitStatus: '',
		};
	},
	watch: {
		qdPopup() {	
			this.popupData = this.qdPopup !== null ? this.qdPopup.data : null;
			this.commentary = false;
			this.submitStatus = '';
		},
	},
	methods: {
		addCommentary() {
			this.commentary = true;
		},
		validateBeforeSubmit( event ) {
			this.$validator.validateAll().then( () => {
				this.submit( event.target );
			});
		},
		submit( el ) {
			this.isSubmitting = true;
			submitForm( el )
			.then( () => {
				this.submitStatus = 'success';

				// TagManager
				trackFormSubmit( 'CourseSignup' );
			})
			.catch( () => {
				this.submitStatus = 'error';
			})
			.always( () => this.isSubmitting = false );
		},
	},
};

/**
 * Posts form to API
 */
function submitForm( el ) {

	const formData = new FormData( el );

	return $.ajax({
		url: '/wp-json/qd/forms/v1/easv_course_signup',
		type: 'POST',
		data: formData,
		cache: false,
		contentType: false,
		processData: false,
	});
}



// WEBPACK FOOTER //
// ./assets/_js/components/course-signup/course-signup.js